import {useContext} from 'react';
import {AuthAPISetupContext} from './AuthAPISetupProvider';

/**
 * Context hook for the AuthAPISetupProvider. This indicates whether the
 * interceptors have been setup and initialized for the frontend api services.
 *
 * @return {{authAPIReady: boolean}}
 */
const useAuthAPISetup = () => {
    const context = useContext(AuthAPISetupContext);

    return context;
};

export default useAuthAPISetup;
